// extracted by mini-css-extract-plugin
module.exports = {"text":"Text-module--text--F0gBl"};